import React from 'react';

export default function AppUpdateModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-950/85 backdrop-blur-md flex items-center justify-center p-4 z-50 animate-fadeIn text-left">
      <div className="bg-slate-900 border-2 border-blue-500 rounded-3xl max-w-lg w-full p-6 md:p-8 relative shadow-2xl space-y-6 max-h-[90vh] overflow-y-auto">
        
        {/* BOTÓN CERRAR */}
        <button
          onClick={onClose}
          className="absolute top-5 right-5 text-slate-400 hover:text-white font-bold text-lg bg-slate-800 w-8 h-8 rounded-full flex items-center justify-center transition cursor-pointer"
        >
          ✕
        </button>

        {/* ENCABEZADO CELEBRATORIO */}
        <div className="flex items-center gap-4 border-b border-slate-800 pb-4">
          <div className="w-14 h-14 bg-gradient-to-tr from-blue-600 via-indigo-600 to-purple-600 rounded-2xl flex items-center justify-center text-3xl shrink-0 shadow-xl">
            🚀
          </div>
          <div>
            <span className="text-[10px] font-black uppercase tracking-widest text-emerald-400 bg-emerald-950 px-2.5 py-0.5 rounded-full border border-emerald-500/30">
              Novedades Oficiales — Versión 2.3
            </span>
            <h3 className="text-xl md:text-2xl font-black text-white mt-1">
              ¡English EOH se ha actualizado!
            </h3>
            <p className="text-xs text-slate-400">IE Enrique Olaya Herrera • Medellín</p>
          </div>
        </div>

        {/* LISTA DE NOVEDADES CLAVE */}
        <div className="space-y-3.5 text-xs md:text-sm text-slate-200">
          
          {/* Novedad 1: Carpetas T2 y T3 */}
          <div className="bg-amber-950/50 border border-amber-500/40 p-4 rounded-2xl space-y-1.5">
            <div className="font-black text-amber-300 flex items-center gap-2 text-sm">
              <span>📁</span> Repositorio Drive: Carpetas T2 y T3 (2026)
            </div>
            <p className="text-slate-300 text-xs leading-relaxed">
              Integración oficial de las carpetas compartidas <strong>T2_Inglés_2026</strong> y <strong>T3_Inglés_2026</strong> en Google Drive para descargar guías y talleres en PDF con acceso directo desde el inicio y el panel docente.
            </p>
          </div>

          {/* Novedad 2: PIN Multidispositivo */}
          <div className="bg-purple-950/50 border border-purple-500/40 p-4 rounded-2xl space-y-1.5">
            <div className="font-black text-purple-300 flex items-center gap-2 text-sm">
              <span>🔑</span> PIN Dinámico de Evaluación Multidispositivo
            </div>
            <p className="text-slate-300 text-xs leading-relaxed">
              El PIN de evaluación ahora sincroniza en tiempo real mediante Cloud Firestore en cualquier celular, tablet o computador, con auto-detección de grado y unidad sin errores de selector.
            </p>
          </div>

          {/* Novedad 3: Reglas Permanentes Cloud */}
          <div className="bg-emerald-950/50 border border-emerald-500/40 p-4 rounded-2xl space-y-1.5">
            <div className="font-black text-emerald-300 flex items-center gap-2 text-sm">
              <span>🛡️</span> Reglas de Seguridad Permanentes en Firestore
            </div>
            <p className="text-slate-300 text-xs leading-relaxed">
              Base de datos asegurada de forma definitiva sin fechas de caducidad, garantizando disponibilidad 24/7 para entregas de exámenes y notas.
            </p>
          </div>

          {/* Novedad 4: Navegación Fluida */}
          <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-1.5">
            <div className="font-black text-white flex items-center gap-2 text-sm">
              <span>✨</span> Navegación Fluida y Botón de Retorno
            </div>
            <p className="text-slate-300 text-xs leading-relaxed">
              Desplazamiento automático al inicio al cambiar de sección y botón rápido de retorno entre el repositorio de guías y el panel docente.
            </p>
          </div>

        </div>

        {/* BOTÓN DE CIERRE */}
        <div className="pt-2">
          <button
            onClick={onClose}
            className="btn-3d btn-3d-blue w-full py-3.5 text-xs md:text-sm font-black gap-2 shadow-2xl"
          >
            🎉 ¡Entendido, explorar la plataforma! 🚀
          </button>
        </div>

      </div>
    </div>
  );
}
